import { userManagementApi } from './user-management.api';

export const userManagementActions = {
  async getAdmins({ commit }, payload) {
    try {
      commit('GET_ADMINS_LOADING');
      const response = await userManagementApi.getAdmins(payload);
      commit('GET_ADMINS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_ADMINS_ERROR', error.response);
    }
  },
  async getAdmin({ commit }, id) {
    try {
      commit('GET_ADMIN_LOADING');
      const response = await userManagementApi.getAdmin(id);
      commit('GET_ADMIN_SUCCESS', response.data);
    } catch (error) {
      commit('GET_ADMIN_ERROR', error.response);
    }
  },
  async addAdmin({ commit }, body) {
    try {
      commit('ADD_ADMIN_LOADING');
      await userManagementApi.addAdmin(body);
      commit('ADD_ADMIN_SUCCESS');
    } catch (error) {
      commit('ADD_ADMIN_ERROR', error.response);
    }
  },
  async updateAdmin({ commit }, { id, body }) {
    try {
      commit('UPDATE_ADMIN_LOADING');
      await userManagementApi.updateAdmin(id, body);
      commit('UPDATE_ADMIN_SUCCESS');
    } catch (error) {
      commit('UPDATE_ADMIN_ERROR', error.response);
    }
  },
  async deleteAdmin({ commit }, id) {
    try {
      commit('DELETE_ADMIN_LOADING');
      const response = await userManagementApi.deleteAdmin(id);
      commit('DELETE_ADMIN_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_ADMIN_ERROR', error.response);
    }
  },
  async updateAdminPassword({ commit }, payload) {
    try {
      commit('UPDATE_ADMIN_PASSWORD_LOADING');
      const response = await userManagementApi.updateAdminPassword(payload);
      commit('UPDATE_ADMIN_PASSWORD_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_ADMIN_PASSWORD_ERROR', error.response);
    }
  },

  async getUsers({ commit }, payload) {
    try {
      commit('GET_USERS_LOADING');
      const response = await userManagementApi.getUsers(payload);
      commit('GET_USERS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_USERS_ERROR', error.response);
    }
  },
  async getUser({ commit }, id) {
    try {
      commit('GET_USER_LOADING');
      const response = await userManagementApi.getUser(id);
      commit('GET_USER_SUCCESS', response.data);
    } catch (error) {
      commit('GET_USER_ERROR', error.response);
    }
  },
  async getUserTransactions({ commit }, payload) {
    try {
      commit('GET_USER_TRANSACTIONS_LOADING');
      const response = await userManagementApi.getUserTransactions(payload);
      commit('GET_USER_TRANSACTIONS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_USER_TRANSACTIONS_ERROR', error.response);
    }
  },
  async getUserSubscriptions({ commit }, payload) {
    try {
      commit('GET_USER_SUBSCRIPTIONS_LOADING');
      const response = await userManagementApi.getUserSubscriptions(payload);
      commit('GET_USER_SUBSCRIPTIONS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_USER_SUBSCRIPTIONS_ERROR', error.response);
    }
  },
  async updateUser({ commit }, { id, body }) {
    try {
      commit('UPDATE_USER_LOADING');
      const response = await userManagementApi.updateUser(id, body);
      commit('UPDATE_USER_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_USER_ERROR', error.response);
    }
  },
};
